// extracted by mini-css-extract-plugin
module.exports = {"item":"item-dBSK8fu"};